import { Button } from 'flowbite-react';
import React from 'react';
import { Link } from 'react-router-dom';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';
import { PiHammerLight } from "react-icons/pi";

const MarketingAgencyDashboard = () => {
  return (
    <>
    <SEO
      title="Marketing Agencies"
      description="Connect with film marketing agencies and manage your marketing partnerships on ProducerBuddy."
      url="https://producerbuddy.pilomation.com/marketing-agencies"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className="flex bg-white">
      {/* Sidebar */}
      <div className="w-64 bg-gray-800 text-white p-5 space-y-6">
        <h1 className="text-2xl p-2 font-bold"><Link to='/marketing-agencies'>Marketing Dashboard</Link></h1>
        <nav>
          <ul className="space-y-4 mt-4">
            <li className="hover:text-yellow-400"><Link to='/marketing-tracker'>Campaign Management</Link></li>
            <li className="hover:text-yellow-400"><Link to='/marketing-collaborations'>Production Collabs</Link></li>
            <li className="hover:text-yellow-400"><Link to='/market-analysis'>Analytics</Link></li>
            <li className="hover:text-yellow-400"><Link to='/clients'>Clients</Link></li>
            <li className="hover:text-yellow-400"><Link to='/marketing-team'>Team</Link></li>
            <li>
              <Link to="/toolmanager" className='flex items-center'>Tool Manager</Link>
            </li>
          </ul>
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 p-8">
        {/* Top Navbar */}
        <div className="flex justify-between items-center bg-white p-4 shadow-md">
          <div>Marketing Dashboard</div>
          <Button><Link to='/add-company'>Add company history</Link></Button>
        </div>

        {/* Main Dashboard */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 mt-6">
          {/* Campaign Overview */}
          <div className="bg-gray-50 p-6 rounded shadow-md">
            <h2 className="text-xl font-bold mb-4">Campaign Overview</h2>
            <div className="space-y-4">
              <div className="p-4 bg-white rounded shadow">Campaign 1 - Progress</div>
              <div className="p-4 bg-white rounded shadow">Campaign 2 - Progress</div>
              <div className="p-4 bg-white rounded shadow">Campaign 3 - Progress</div>
            </div>
          </div>

          {/* Analytics Section */}
          <div className="bg-gray-50 p-6 rounded shadow-md">
            <h2 className="text-xl font-bold mb-4">Market Analytics</h2>
            <div className="space-y-4">
              <div className="p-4 bg-white rounded shadow">Engagement Analysis</div>
              <div className="p-4 bg-white rounded shadow">Audience Insights</div>
              <div className="p-4 bg-white rounded shadow">Conversion Rates</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
    
  );
};

export default MarketingAgencyDashboard;

